module.exports = __webpack_public_path__ + "img/20200514_144338.9c724f8a.jpg";